module.exports = __webpack_public_path__ + "images/internal/datashake/it_central_station.png";